import {
  ReportAddedPoints, ReportAdvertisementViewing,
  ReportAI, ReportAppPenetration, ReportAttendantGoalAchievement,
  ReportApprovedTransactions, ReportAttendant, ReportBillings, ReportBlockedCustomers,
  ReportConcentratorError,
  ReportCoupons,
  ReportCurrentFillins,
  ReportCustomerRecovery,
  ReportCustomersWithoutDrawing,
  ReportDefaultPoints, ReportDeliveries, ReportDetailedPoints, ReportDeviceCustomer, ReportDeviceManufacture, ReportDiscount,
  ReportProductPoints,
  ReportOperationsStatement,
  ReportDotzRefuelTransactions,
  ReportDrawing,
  ReportExpirationByCustomer,
  ReportExpirationByDate, ReportExternalPartners, ReportFavoriteStation, ReportFillinByAttendant, ReportFillinByCustomer,
  ReportFillinByFuel,
  ReportFillinByStation,
  ReportFillins,
  ReportGiftClub,
  ReportFirstFillinByAttendant,
  ReportFirstFillinByStation,
  ReportInactiveCustomers,
  ReportInventory,
  ReportInvoices,
  ReportOverdueBills,
  ReportBillingIssues,
  ReportStationsWithoutBills,
  ReportStationsCTTValue,
  ReportMinimumStock, ReportMonthlyEvolution, ReportNewCustomers,
  ReportNewCustomersByPromoters,
  ReportNotifications, ReportPartners, ReportPartnerValues,
  ReportPaymentsByPix,
  ReportPendingTransaction,
  // ReportPoints,
  ReportPriceDivergence,
  ReportEmployeeSessions,
  ReportPointsBalance,
  ReportPointsExpiration, ReportProducts, ReportProductsStock, ReportPurchaseSuggestion,
  ReportPushNotifications,
  ReportRatingPollGroup, ReportRealPrice,
  ReportRecurringCustomers,
  ReportRedemption, ReportRedemptionXPoints, ReportReferedCustomers,
  ReportRegisteredDiscounts, ReportRetailers, ReportRoleta, ReportScoring, ReportSocketError,
  ReportSoldProducts, ReportStation, ReportStationRating,
  ReportSyntheticProductsStock,
  ReportTopCustomers,
  ReportQualityPaymentValidation,
  ReportLiveMap,
  RdpContingencies,
} from './resources/reports';
import { CustomerVoice, Painel360 } from './resources/dashboards';
import CustomerRfmPage from './resources/customerRfm/CustomerRfmPage';
import { PartnerPaymentList, PartnerPaymentShow } from './resources/partnerPayments';
import { SupportAgentReport } from './components/SupportChat';

import FillinCashback from './resources/cashback/fillinCashback';
import FuelPrices from './resources/fuelsPrices/FuelPrices';
import {
  ProductAdjustment, ProductEntry, ProductTransfer, ProductWriteOff
} from './resources/inventory';
import ChangePassword from './resources/password/ChangePassword';
import AddPoints from './resources/points/AditionPoints';
import AddPointsByRefuel from './resources/points/AditionPointsByRefuel';
import DefaultPoints from './resources/points/DefaultPoints';
import DefaultPointsFuels from './resources/points/DefaultPointsFuels';
import Rules from './resources/points/SpecialRules';
import PotencialFraudRules from './resources/PotencialFraudRules/PotencialFraudRules';
import CustomerFraudIgnored from './resources/customerFraudIgnored/customerFraudIgnored';
import SpotlightProducts from './resources/spotlightProducts';

import AttendantDeletedUserList from './resources/attendantUsers/AttendantDeletedUserList';
import PlaceDeletedUserList from './resources/externalPartners/PlaceDeletedUserList';
import MapListStations from './resources/mapStations/index';
import ImportPoints from './resources/points/ImportPoints';
import ReportRegistrationCustomer from './resources/reports/ReportRegistrationCustomer';

import Dashboard from './Dashboard';
import CLientDeletedList from './resources/lgpd/ClientDeleted';
import TermsOfUseList from './resources/lgpd/TermsOfUseList';
import ReportCustomers from './resources/reports/ReportCustomers';
import DeletedUserList from './resources/users/DeletedUserList';
import ReportLifePoints from './resources/reports/ReportLifePoints';
import MinimumAmountRule from './resources/points/MinimumAmountRule';
import AttendantGoalBoardMonitor from './resources/attendantGoalBoardMonitor';
import AttendantGoalTrial from './resources/attendantGoalTrial';
import ManualIndex from './manual/components/ManualIndex';
import ManualPage from './manual/components/ManualPage';
import PopUpEdit from './resources/popUps/PopUpEdit';
// Diretório, não arquivo: o ProductEvolution.tsx antigo foi removido e a
// resolução agora cai em ProductEvolution/index.tsx (a carteira).
import ProductEvolution from './resources/dashboards/ProductEvolution';
import ChainDetailView from './resources/dashboards/ProductEvolution/ChainDetailView';
import CouponIntegrationHealth from './resources/dashboards/CouponIntegrationHealth';
import EcosystemHub from './resources/dashboards/EcosystemHub';
import CustomerLifecyclePage from './resources/customerLifecycle/CustomerLifecyclePage';
import DeviceSessions from './resources/deviceSessions';
import DiscountCreateClassic from './resources/discounts/v2/ClassicRoute';

export default [
  // { path: '/fuel-discounts', element: <FuelDiscountsList/> },
  // { path: '/report-points', element: <ReportPoints/> },
  { path: '/_employees/recovery', element: <PlaceDeletedUserList /> },
  { path: '/add-points', element: <AddPoints /> },
  { path: '/add-points-by-refuel', element: <AddPointsByRefuel /> },
  { path: '/attendant-employees/recovery', element: <AttendantDeletedUserList /> },
  { path: '/chains/chainId/featured-products', element: <SpotlightProducts /> },
  { path: '/chains/chainId/fillin-cashback', element: <FillinCashback /> },
  { path: '/fuel-prices-edit', element: <FuelPrices /> },
  { path: '/change-password', element: <ChangePassword /> },
  { path: '/customers-deleted', element: <CLientDeletedList /> },
  { path: '/dashboard', element: <Dashboard /> },
  { path: '/default-points-edit', element: <DefaultPoints /> },
  { path: '/default-points-fuels-edit', element: <DefaultPointsFuels /> },
  { path: '/employees/recovery', element: <DeletedUserList /> },
  { path: '/import-points', element: <ImportPoints /> },
  { path: '/manual', element: <ManualIndex /> },
  { path: '/manual/:slug', element: <ManualPage /> },
  { path: '/map-stations', element: <MapListStations /> },
  { path: '/minimum-amount-rule-edit', element: <MinimumAmountRule /> },
  { path: '/report-added-points', element: <ReportAddedPoints /> },
  { path: '/report-advertisement-viwing', element: <ReportAdvertisementViewing /> },
  { path: '/report-app-penetration', element: <ReportAppPenetration /> },
  // Tela "Segmentos de valor" (RFM) — filha do Painel 360: item no submenu "Painel 360"
  // e botão "Ver detalhes" do card RFM (LoyaltySection.tsx), igual ao Ciclo de vida.
  { path: '/customer-rfm', element: <CustomerRfmPage /> },
  { path: '/report-approved-transactions', element: <ReportApprovedTransactions /> },
  { path: '/report-attendant', element: <ReportAttendant /> },
  { path: '/report-billings', element: <ReportBillings /> },
  { path: '/report-invoices', element: <ReportInvoices /> },
  { path: '/report-overdue-bills', element: <ReportOverdueBills /> },
  { path: '/report-billing-issues', element: <ReportBillingIssues /> },
  { path: '/report-stations-without-bills', element: <ReportStationsWithoutBills /> },
  { path: '/report-stations-ctt-value', element: <ReportStationsCTTValue /> },
  { path: '/report-blocked-customers', element: <ReportBlockedCustomers /> },
  { path: '/report-coupons', element: <ReportCoupons status={undefined} /> },
  { path: '/report-concentrator-error', element: <ReportConcentratorError /> },
  { path: '/report-current-fillins', element: <ReportCurrentFillins /> },
  { path: '/report-live-map', element: <ReportLiveMap /> },
  { path: '/report-customers', element: <ReportCustomers /> },
  { path: '/report-customers-without-drawing', element: <ReportCustomersWithoutDrawing /> },
  { path: '/report-default-points', element: <ReportDefaultPoints /> },
  { path: '/report-deliveries', element: <ReportDeliveries /> },
  { path: '/report-detailed-points', element: <ReportDetailedPoints /> },
  { path: '/report-product-points', element: <ReportProductPoints /> },
  { path: '/report-operations-statement', element: <ReportOperationsStatement /> },
  { path: '/report-device-customer', element: <ReportDeviceCustomer /> },
  { path: '/report-device-manufacturer', element: <ReportDeviceManufacture /> },
  { path: '/report-discount', element: <ReportDiscount /> },
  { path: '/report-dotz-refuel-transactions', element: <ReportDotzRefuelTransactions /> },
  { path: '/report-drawing', element: <ReportDrawing /> },
  { path: '/report-expiration-by-customer', element: <ReportExpirationByCustomer /> },
  { path: '/report-expiration-by-date', element: <ReportExpirationByDate /> },
  { path: '/report-expired-points', element: <ReportPointsExpiration /> },
  { path: '/report-external-partners', element: <ReportExternalPartners /> },
  { path: '/report-favorite-station', element: <ReportFavoriteStation /> },
  { path: '/report-attendant-goal-achievement', element: <ReportAttendantGoalAchievement /> },
  { path: '/report-fillin-by-attendant', element: <ReportFillinByAttendant /> },
  { path: '/report-fillin-by-customer', element: <ReportFillinByCustomer /> },
  { path: '/report-fillin-by-fuel', element: <ReportFillinByFuel /> },
  { path: '/report-fillin-by-station', element: <ReportFillinByStation /> },
  { path: '/report-fillins', element: <ReportFillins /> },
  { path: '/report-gifts', element: <ReportGiftClub /> },
  { path: '/report-roleta', element: <ReportRoleta /> },
  { path: '/report-first-fillin-by-attendant', element: <ReportFirstFillinByAttendant /> },
  { path: '/report-first-fillin-by-station', element: <ReportFirstFillinByStation /> },
  { path: '/report-inactive-customers', element: <ReportInactiveCustomers /> },
  { path: '/report-inventory', element: <ReportInventory /> },
  { path: '/report-life-points', element: <ReportLifePoints /> },
  { path: '/report-minimum-stock', element: <ReportMinimumStock /> },
  { path: '/report-monthly-evolution', element: <ReportMonthlyEvolution /> },
  { path: '/report-new-customers', element: <ReportNewCustomers /> },
  { path: '/report-new-customers-by-promoters', element: <ReportNewCustomersByPromoters /> },
  { path: '/report-non-validated-coupons', element: <ReportCoupons status="not-redeemed" /> },
  { path: '/report-notifications', element: <ReportNotifications /> },
  { path: '/report-partner-values', element: <ReportPartnerValues /> },
  { path: '/report-partners', element: <ReportPartners /> },
  { path: '/report-payments-by-pix', element: <ReportPaymentsByPix /> },
  { path: '/report-pending-transaction', element: <ReportPendingTransaction /> },
  { path: '/report-points-balance', element: <ReportPointsBalance /> },
  { path: '/report-products', element: <ReportProducts /> },
  { path: '/report-products-stock', element: <ReportProductsStock /> },
  { path: '/report-purchase-suggestion', element: <ReportPurchaseSuggestion /> },
  { path: '/report-push-notifications', element: <ReportPushNotifications /> },
  { path: '/report-customer-recovery', element: <ReportCustomerRecovery /> },
  { path: '/report-rating-poll-group', element: <ReportRatingPollGroup /> },
  { path: '/report-real-price', element: <ReportRealPrice /> },
  { path: '/report-recurring-customers', element: <ReportRecurringCustomers /> },
  { path: '/report-redeemed-coupons', element: <ReportCoupons status="redeemed" /> },
  { path: '/report-redemption', element: <ReportRedemption /> },
  { path: '/report-redemption-x-points', element: <ReportRedemptionXPoints /> },
  { path: '/report-refered-customers', element: <ReportReferedCustomers /> },
  { path: '/report-refunded-coupons', element: <ReportCoupons status="refunded" /> },
  { path: '/report-registered-discounts', element: <ReportRegisteredDiscounts /> },
  { path: '/report-registration-customers', element: <ReportRegistrationCustomer /> },
  { path: '/report-retailers', element: <ReportRetailers /> },
  { path: '/report-scoring', element: <ReportScoring /> },
  { path: '/report-price-divergence', element: <ReportPriceDivergence /> },
  { path: '/report-employee-sessions', element: <ReportEmployeeSessions /> },
  { path: '/report-socket-error', element: <ReportSocketError /> },
  { path: '/report-sold-products', element: <ReportSoldProducts /> },
  { path: '/report-station', element: <ReportStation /> },
  { path: '/report-station-rating', element: <ReportStationRating /> },
  { path: '/report-synthetic-products-stock', element: <ReportSyntheticProductsStock /> },
  { path: '/report-top-customers', element: <ReportTopCustomers /> },
  { path: '/security-rules-edit', element: <PotencialFraudRules /> },
  { path: '/customers-fraud-ignored', element: <CustomerFraudIgnored /> },
  { path: '/special-rules', element: <Rules /> },
  { path: '/terms-use', element: <TermsOfUseList /> },
  { path: '/warehouse/adjustment', element: <ProductAdjustment /> },
  { path: '/warehouse/product-entry', element: <ProductEntry /> },
  { path: '/warehouse/product-transfer', element: <ProductTransfer /> },
  { path: '/warehouse/product-write-off', element: <ProductWriteOff /> },
  { path: '/pop-ups', element: <PopUpEdit /> },
  { path: '/attendant-goal-boards/monitor', element: <AttendantGoalBoardMonitor /> },
  { path: '/attendant-goal-trial', element: <AttendantGoalTrial /> },
  { path: '/partner-payments', element: <PartnerPaymentList /> },
  { path: '/partner-payments/:id/show/*', element: <PartnerPaymentShow /> },
  { path: '/support-agent-report', element: <SupportAgentReport /> },
  { path: '/rdp-contingencies', element: <RdpContingencies /> },
  { path: '/report-quality-payment-validation', element: <ReportQualityPaymentValidation /> },
  { path: '/report-ai', element: <ReportAI /> },
  { path: '/dashboard-comments', element: <CustomerVoice /> },
  { path: '/dashboard-evolution', element: <ProductEvolution /> },
  { path: '/dashboard-evolution/:chainId', element: <ChainDetailView /> },
  { path: '/coupon-integration-health', element: <CouponIntegrationHealth /> },
  { path: '/dashboard-v2', element: <Painel360 /> },
  { path: '/ecosystem-hub', element: <EcosystemHub /> },
  { path: '/customer-lifecycle', element: <CustomerLifecyclePage /> },
  { path: '/device-sessions', element: <DeviceSessions /> },
  { path: '/discounts/create-classic', element: <DiscountCreateClassic /> },
];
